var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("display-items", {
    attrs: { namespace: "logbook" },
    scopedSlots: _vm._u([
      {
        key: "cards",
        fn: function({ items }) {
          return [
            _c(
              "div",
              _vm._l(items, function(entry) {
                return _c("entry-card", {
                  key: entry.id,
                  staticClass: "my-3",
                  attrs: { entry: entry },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function() {
                          return [
                            _vm.isEditMode
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "mx-3",
                                    attrs: { small: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleSelectClick(entry)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            SELECTIONNER\n          "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                })
              }),
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }